<form [meta]="model" #form="ngForm">
  <div class="modal-header">
    <h3 class="modal-title">{{"AufbereitungsoptionenRechteAuszug"}} | translate</h3>
    <button (click)="activeModal.close(true)" aria-label="Close" class="btn-close" type="button"></button>
  </div>

  <div class="modal-body">
    <div class="container-fluid mx-0 px-0">
      <form #form="ngForm" column-classes="col-md-2,col-md-10">
        <h2>{{ title }}</h2>

        <br />
        <h3 class="title-divider">{{"Inhalt" | translate}}</h3>
        <cap-form-control labelKey="VertragstexteAufbereiten">
          <input [(ngModel)]="model.vertragstextAufbereiten" name="vertragstextAufbereiten" type="checkbox" />
        </cap-form-control>
        @if (hasToZip) {
          <cap-form-control labelKey="AuszugBearbeiten">
            <input
              (ngModelChange)="model && (model.auszugBearbeiten = $event)"
              [disabled]="model.inEinemDokumentDrucken"
              [ngModel]="model && model.auszugBearbeiten"
              name="AuszugBearbeiten"
              type="checkbox" />
          </cap-form-control>
        }
        @if (hasRequiredErweiterung && hasToZip) {
          <cap-form-control labelKey="InEinemDokumentDrucken">
            <input
              (ngModelChange)="model && (model.inEinemDokumentDrucken = $event)"
              [disabled]="model.auszugBearbeiten"
              [ngModel]="model && model.inEinemDokumentDrucken"
              name="InEinemDokumentDrucken"
              type="checkbox" />
          </cap-form-control>
        }
        <br />
        <h3 class="title-divider">{{"Einstellungen" | translate}}</h3>

        <button (click)="resetSettings()" class="btn btn-outline-primary" type="button">
          {{ "EinstellungenZuruecksetzen" | translate }}
        </button>
      </form>
    </div>
  </div>
  <div class="modal-footer">
    <button (click)="activeModal.close(false)" class="btn btn-outline-primary" type="button">{{ "Abbrechen" | translate }}</button>
    <button (click)="confirm()" class="btn btn-primary" type="button">{{ "AuszugErstellen" | translate }}</button>
  </div>
</form>
